<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <div class="bell" v-if="isShoeBell">
        <el-popover
          placement="top"
          width="400"
          v-model="notification.visible"
          trigger="manual"
          class="bell-popover"
          @show="getShoebell"
        >
          <div class="bell-heater">
            <div class="left">
              <!-- <i class="el-icon-bell"></i> -->
              <span class="title">通知</span>
            </div>
            <div class="right">
              <i
                class="el-icon-close close-item"
                @click="notification.visible = false"
              ></i>
            </div>
          </div>

          <div class="bell-body">
            <div class="bell-list">
              <div
                class="bell-list-item"
                v-for="(item, index) in notification.bellList"
                :key="index"
                @click="goBellDetail(item)"
              >
                <div class="status" v-if="item.status == 0"></div>
                <div class="body">
                  <div class="title ellipsis">{{ item.title }}</div>

                  <div class="name ellipsis">{{ item.content }}</div>

                  <div class="type-time">
                    <div>类型：{{ item.typeName }}</div>
                    <div style="margin-left: 10px">
                      发送时间：{{ item.createTime | formatTime }}
                    </div>
                  </div>
                </div>
                <el-link :underline="false">>>></el-link>
              </div>
            </div>

            <div class="bell-button" v-if="isShowBell">
              <el-button type="text" @click="allRead">全部已读</el-button>
              <el-link :underline="false" @click="goBellList"
                >查看更多></el-link
              >
            </div>
          </div>
          <div
            style="cursor: pointer"
            slot="reference"
            @click="notification.visible = true"
          >
            <el-badge
              :value="notification.bellCount"
              :hidden="!notification.bellCount"
              :max="99"
            >
              <i class="el-icon-bell"></i>
            </el-badge>
          </div>

          <!-- <el-button slot="reference">删除</el-button> -->
        </el-popover>
      </div>
      <template v-if="device !== 'mobile'"></template>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span>{{ mobile }}</span>
          <i class="el-icon-caret-bottom" style="font-size: 20px" />
        </div>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="openSwitchDept"
            v-if="!getPlateForm()"
          >
            <span style="display: block">切换岗位</span>
          </el-dropdown-item>

          <el-dropdown-item
            @click.native="modifyPassword"
            v-if="!getPlateForm()"
          >
            <span style="display: block">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <updatePwdDialog ref="updatePwdDialog" />
    <switchDept ref="switchDept" @setUserDept="setUserDept" />
  </div>
</template>

<script>
  import {
    getMessageNoticeLatest,
    postMessageMarkReadByUid
  } from '@/api/notifications-management';
  import { mapGetters, mapState } from 'vuex';
  import Breadcrumb from '@/components/Breadcrumb';
  import Hamburger from '@/components/Hamburger';
  import { logOut } from '@/api/user';
  import { clearAll } from '@/utils/clear-user-information';
  import { getPlateForm } from '@/utils/auth';
  import updatePwdDialog from '@/views/login/components/UpdatePassWord';
  import switchDept from '@/views/login/components/switchDept';
  import { baseCDNUrl } from '@/utils/data-update';
  import dayjs from 'dayjs';
  import { checkUserPermission } from '@/directives/index';

  export default {
    components: {
      Breadcrumb,
      Hamburger,
      updatePwdDialog,
      switchDept
    },
    filters: {
      formatTime(val) {
        if (val) {
          return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
        }
        return '';
      }
    },
    watch: {
      'notification.visible'(val) {
        if (!this.isShoeBell) return;

        if (val) {
          // 弹窗打开时，暂停定时器
          this.stopPolling();
        } else {
          // 弹窗关闭时，重启定时器
          this.startPolling();
        }
      }
    },
    data() {
      return {
        userInfo: {},
        getPlateForm,
        // 站内信通知系统
        notification: {
          visible: false, // 弹窗显示状态
          bellList: [], // 通知列表
          bellCount: 0, // 未读数量
          intervalId: null, // 定时器ID
          errorCount: 0, // 连续错误计数
          maxErrorCount: 3 // 最大连续错误次数，超过后停止轮询
        }
      };
    },

    computed: {
      ...mapGetters(['sidebar', 'avatar', 'device']),
      ...mapState({
        configSource: (state) => state.app.configSource
      }),
      mobile() {
        // 优先显示姓名，其次显示手机号
        const userInfo = localFun.get('userInfo');
        if (userInfo == 'undefined') {
          return localFun.get('mobile') || '';
        }
        return (
          JSON.parse(localFun.get('userInfo'))?.name || localFun.get('mobile')
        );
      },
      isShoeBell() {
        // 通知只在小后台显示，小后台时getPlateForm返回false
        return !this.getPlateForm() && this.configSource?.pushConfig?.inbox;
      },
      isShowBell() {
        return checkUserPermission('message-management');
      }
    },
    async created() {
      const userInfo = localFun.get('userInfo');
      if (userInfo !== 'undefined') {
        this.userInfo = JSON.parse(userInfo);
      }

      if (this.isShoeBell) {
        // 首次加载获取通知
        await this.getShoebell();
        // 启动定时轮询
        this.startPolling();
      }

      // 监听站内信列表页面的刷新事件
      this.$root.$on('refresh-navbar-bell', this.handleRefreshBell);
    },
    methods: {
      handleRefreshBell() {
        // 刷新导航栏未读消息数量
        this.getShoebell();
      },
      goBellDetail(item) {
        // 关闭弹窗
        this.notification.visible = false;

        // 如果是未读消息，乐观更新未读数量
        if (item.status === 0 && this.notification.bellCount > 0) {
          this.notification.bellCount--;
        }

        // 跳转到详情页
        this.$router
          .push({
            name: 'notifications-detail',
            query: {
              id: item.receiveId
            }
          })
          .catch((err) => {
            // 处理路由跳转错误（如重复导航）
            if (err.name !== 'NavigationDuplicated') {
              // 回滚未读数量
              if (item.status === 0) {
                this.notification.bellCount++;
              }
            }
          });
      },
      goBellList() {
        this.$router.push({
          name: 'notifications-list'
        });
        this.notification.visible = false;
      },
      allRead() {
        this.$confirm('是否确认全部已读?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async () => {
            try {
              this.stopPolling();
              await postMessageMarkReadByUid();
              this.$message({
                type: 'success',
                message: '操作成功'
              });

              await this.getShoebell();
              this.startPolling();

              // 如果当前在站内信列表页面，延迟2秒后通知页面刷新
              if (this.$route.name === 'notifications-list') {
                setTimeout(() => {
                  this.$root.$emit('refresh-notifications-list');
                }, 2000);
              }
            } catch (e) {
              this.Sentry.captureException(e);
              this.startPolling();
            }
          })
          .catch(() => {});
      },
      async getShoebell() {
        try {
          const res = await getMessageNoticeLatest();
          this.notification.bellCount = res.unreadCount;
          this.notification.bellList = res.messageList;
          // 请求成功，重置错误计数
          this.notification.errorCount = 0;
        } catch (error) {
          this.notification.errorCount++;

          // 仅首次失败上报 Sentry
          if (this.notification.errorCount === 1) {
            this.Sentry.captureException(error);
          }

          // 连续失败达到阈值，停止轮询
          if (this.notification.errorCount >= this.notification.maxErrorCount) {
            this.stopPolling();
          }
        }
      },
      // 启动轮询定时器
      startPolling() {
        // 先清理旧定时器，避免重复创建
        this.stopPolling();
        // 重置错误计数
        this.notification.errorCount = 0;
        // 创建定时器，每60秒轮询一次
        this.notification.intervalId = setInterval(() => {
          this.getShoebell();
        }, 60000);
      },
      // 停止轮询定时器
      stopPolling() {
        if (this.notification.intervalId) {
          clearInterval(this.notification.intervalId);
          this.notification.intervalId = null;
        }
      },
      toggleSideBar() {
        this.$store.dispatch('app/toggleSideBar');
      },
      modifyPassword() {
        this.$refs['updatePwdDialog'].showDialog = true;
      },
      async logout() {
        try {
          await logOut();
          clearAll();
          this.$router.push('/login');

          const link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement('link');
          link.type && link.parentNode.removeChild(link);
          const url = baseCDNUrl + 'logo.png?v=0'; // 登录页页签logo
          this.getLogoWidth(url);
          this.setTitleLogo(url);
        } catch (error) {
          this.Sentry.captureException(error);
        }
      },
      async openSwitchDept() {
        this.$refs['switchDept'].open();
      },
      async handleSwitchRole() {
        //因为弹窗有嵌套 会影响层级 故把弹窗放在父组件
        this.$emit('showProxyApprovalSettingDialog');
      },
      setUserDept(dept) {
        this.$set(this.userInfo, 'currentDepartmentName', dept);
      },
      setTitleLogo(url) {
        const link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = url;
        document.getElementsByTagName('head')[0].appendChild(link);
      },
      getLogoWidth(url) {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          this.height = (this.width * img.height) / img.width;
        };
      }
    },
    beforeDestroy() {
      // 组件销毁时清理定时器
      this.stopPolling();
      // 移除事件监听
      this.$root.$off('refresh-navbar-bell', this.handleRefreshBell);
    }
  };
</script>

<style lang="scss" scoped>
  // dialog水平垂直居中
  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    .el-dialog__body {
      max-height: 100%;
      padding: 20px;
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      .el-form {
        .el-form-item {
          .el-form-item__label {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
    .el-dialog__footer {
      padding-top: 0px;
    }
  }

  .el-form-item {
    & > ::v-deep .el-form-item__content {
      .show-pwd {
        position: absolute;
        right: 44px;
        top: 4px;
        font-size: 16px;
        color: #889aa4;
        cursor: pointer;
        user-select: none;
      }
      .icon-clear {
        position: absolute;
        right: 10px;
        top: 4px;
        font-size: 16px;
        color: #889aa4;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .navbar {
    height: 50px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    z-index: 1;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    .hamburger-container {
      line-height: 46px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }

    .right-menu {
      float: right;
      height: 100%;
      line-height: 50px;

      .bell {
        display: inline-block;
        margin-right: 20px;
        height: 100%;
        line-height: 0;
        vertical-align: middle;
        //cursor: pointer;

        .el-icon-bell {
          font-size: 18px;
        }
      }

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background 0.3s;

          &:hover {
            background: rgba(0, 0, 0, 0.025);
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          span {
            font-size: 12px;
          }
          .user-info {
            line-height: 24px;
            display: flex;
            cursor: pointer;
            // width: 200px;
            padding: 10px 0;
            .user-avatar {
              width: 32px;
              height: 32px;
              background: #3ccf8f;
              border-radius: 4px 4px 4px 4px;
              color: #e8f7f3;
              font-weight: 500;
              font-size: 14px;
              line-height: 32px;
              text-align: center;
            }
            .user-box {
              margin-left: 12px;
              min-width: 120px;
              max-width: 180px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .user-name {
                font-weight: 600;
                font-size: 14px;
                color: #191919;
                line-height: 14px;
              }
              .user-dept {
                margin-top: 4px;
                font-weight: 500;
                font-size: 12px;
                color: #757575;
                line-height: 12px;
              }
            }
          }

          .el-icon-caret-bottom {
            margin-left: 10px;
            cursor: pointer;
            font-size: 12px;
          }
        }
      }
    }
  }
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .bell-heater {
    display: flex;
    justify-content: space-between;
    .left {
      font-weight: 700;
      font-size: 16px;
      color: #303133;
      .title {
        // margin-left: 10px;
      }
    }
    .right {
      .close-item {
        cursor: pointer;
        color: #909399;
        font-size: 16px;
      }
    }
  }
  .bell-body {
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    .bell-list {
      display: flex;
      flex-direction: column;
      max-height: 200px;
      min-height: 50px;
      overflow: auto;
      .bell-list-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-right: 10px;
        .status {
          &::after {
            content: '';
            display: flex;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: red;
          }
        }
        .body {
          margin-left: 20px;
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          font-size: 12px;
          color: #303133;
          margin-right: 10px;
          .title {
            font-weight: 700;
            font-size: 14px;
            margin-bottom: 4px;
          }
          .name {
            margin-bottom: 4px;
          }
          .type-time {
            display: flex;
          }
        }
      }
    }
    .bell-button {
      font-size: 12px;
      color: #303133;
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
    }
  }
</style>
